import React from 'react';
import { CalendarDays, Heart, MapPin, Download } from 'lucide-react';

const Proposal = () => {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_#ffe8f3_0%,_#ffd9ea_45%,_#ffd0e5_100%)] px-4 py-10 flex items-center justify-center">
      <div className="w-full max-w-4xl rounded-3xl border border-[#f3cada] bg-white/95 shadow-2xl overflow-hidden">
        <div className="px-6 md:px-10 pt-8 md:pt-10 pb-5 text-center border-b border-[#f7ddeb]">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#ffe7f2] text-[#aa2e6c] px-4 py-1.5 text-sm font-medium">
            <Heart size={16} fill="currentColor" />
            Final Reveal
          </div>
          <h1 className="mt-4 text-3xl md:text-5xl font-semibold tracking-tight text-[#271923]">can't wait :)</h1>
          <p className="mt-2 text-[#5a4452]">btw you made this little guy happy</p>
        </div>

        <div className="grid md:grid-cols-[1.1fr_1fr] gap-0">
          <div className="p-6 md:p-10 bg-[#fff8fc]">
            <img
              src={`${process.env.PUBLIC_URL}/assets/rohit.jpg`}
              alt="Rohit"
              className="w-full h-full max-h-[420px] object-cover rounded-2xl shadow-lg"
            />
          </div>

          <div className="p-6 md:p-10 flex flex-col justify-center">
            <h2 className="text-2xl font-semibold text-[#2a1b24]">Date w Rohit</h2>
            <div className="mt-6 space-y-4 text-[#3a2a34]">
              <div className="flex items-start gap-3">
                <CalendarDays size={20} className="mt-0.5 text-[#b62e73]" />
                <div>
                  <p className="font-medium">When</p>
                  <p>February 14, 2026 · 1:00 PM to 3:00 PM</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <MapPin size={20} className="mt-0.5 text-[#b62e73]" />
                <div>
                  <p className="font-medium">Where</p>
                  <p>??? - suprise hehehehaw</p>
                </div>
              </div>
            </div>

            <a
              href="/valentine-date.ics"
              download
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-lg bg-[#df2f84] text-white px-5 py-3 font-medium hover:bg-[#ca236f] transition-colors"
            >
              <Download size={18} />
              click to reserve me
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Proposal;
